import cn from "classnames";
import React from "react";

const Grid = ({ className = "", children, id = "" }) => {
  return (
    <div
      {...(id ? { id } : {})}
      className={cn("grid-container-grid grid-row", className)}
    >
      {children}
    </div>
  );
};

export default Grid;
